/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { FormFieldProps } from '../../FormField.props';

/**
 * The props for `<Toggle />`.
 */
export interface ToggleProps extends FormFieldProps {
  /**
   * The function to return the checked state boolean.
   */
  callback?(value: boolean): void;

  /**
   * Checked state.
   */
  checked?: boolean;

  /**
   * Label text for disabling a toggle.
   */
  toggleTextDisable?: string;

  /**
   * Label text for enabling a toggle.
   */
  toggleTextEnable?: string;
}

/**
 * The default prop values for `<Toggle />`.
 */
export const togglePropsDefaults = {
  checked: false,
  toggleTextDisable: `Disable this option`,
  toggleTextEnable: `Enable this option`,
};
